export const FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST = "FETCH_DOCTORS_PACKAGES_PAYMENT_REQUEST";
export const UPDATE_DOCTORS_PACKAGES_PAYMENT_REQUEST = "UPDATE_DOCTORS_PACKAGES_PAYMENT_REQUEST";
